import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Modal from '../Modal/Modal';

const Leaves = () => {
    const { phone } = useParams();
    const [leaves, setLeaves] = useState();
    const [ViewModelData, setViewModelData] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [rejectIndex, setRejectIndex] = useState(null);
    const location = useLocation();
    const {  leaveData } = location.state || {}; // Destructuring state


    const getLeaves = async () => {
        try {
            const requestOptions = {
                method: "GET",
                redirect: "follow"
            };
              
            fetch(`https://api.experts4u.in/api/v1/ServiceProviderleaves/GetProviderleaves/${phone}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    setLeaves(result.data[0]);
                })
                .catch(error => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

   

    const LeavesStatusUpdate = async (index, Status, rejectreason = "") => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "ContactNo": phone,
                "index": index,
                "Status": Status,
                "rejectreason": rejectreason
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://api.experts4u.in/api/v1/ServiceProviderleaves/LeaveStausUpdate", requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    getLeaves();
                    setIsRejectModalOpen(false);
                    setRejectReason("");
                })
                .catch(error => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getLeaves();
    }, []);

    return (
        <div className="container-fluid py-5">
            <div className="row justify-content-center">
                <div className="col-md-11">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div>Leaves</div>
                        <div>
                            <p>Name: {leaves?.Name}</p>
                            <p>Phone: {leaves?.ContactNo}</p>
                        </div>
                    </div>

                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>StartDate</th>
                                    <th>EndDate</th>
                                    <th>Reason</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leaves?.leaves?.map((leave, index) => (
                                    
                                    <tr style={ leaveData?.CreatedAt && ( leave?.CreatedAt == leaveData?.CreatedAt? {} : {display: "none"})} key={leave._id}>

                                        
                                        <td>{new Date(leave.StartDate).toLocaleDateString()}</td>
                                        <td>{new Date(leave.EndDate).toLocaleDateString()}</td>
                                        <td>{(leave.Reason).length > 20 ? leave.Reason.substring(0, 20) + "..." : leave.Reason}</td>
                                        <td>{leave.Status}</td>
                                        <td>
                                            <button className="btn btn-primary" onClick={() => LeavesStatusUpdate(index, "Accepted")}>Accept</button>
                                            <button className="btn btn-danger" onClick={() => {
                                                setRejectIndex(index);
                                                setIsRejectModalOpen(true);
                                            }}>Reject</button>
                                            <button className="btn btn-primary" onClick={() => {
                                                setViewModelData(leave);
                                                setIsModalOpen(true);
                                            }}>View</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {/* View Leave Details Modal */}
                        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                            <div className="leave-details">
                                <h3>Leave Details</h3>
                                <div className="mb-3">
                                    <strong>Start Date:</strong> {ViewModelData.StartDate && new Date(ViewModelData.StartDate).toLocaleDateString()}
                                </div>
                                <div className="mb-3">
                                    <strong>End Date:</strong> {ViewModelData.EndDate && new Date(ViewModelData.EndDate).toLocaleDateString()}
                                </div>
                                <div className="mb-3">
                                    <strong>Status:</strong> {ViewModelData.Status}
                                </div>
                                <div className="mb-3">
                                    <strong>Reason:</strong>
                                    <p>{ViewModelData.Reason}</p>
                                </div>
                            </div>
                        </Modal>

                        {/* Reject Leave Modal */}
                        <Modal isOpen={isRejectModalOpen} onClose={() => setIsRejectModalOpen(false)}>
                            <div className="leave-reject">
                                <h3>Reject Leave</h3>
                                <label>Enter Reject Reason:</label>
                                <textarea
                                    className="form-control"
                                    value={rejectReason}
                                    onChange={(e) => setRejectReason(e.target.value)}
                                />
                                <div className="mt-3">
                                    <button className="btn btn-danger" onClick={() => LeavesStatusUpdate(rejectIndex, "Rejected", rejectReason)}>Confirm Reject</button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Leaves;
